<template>
  <div id="player-container">
    <div v-show="url && url.includes('content.digicampus.co.za')" class="player">
      <video class="video-js" ref="videojs" autoplay controls></video>
    </div>
  </div>
</template>

<script>
  import videojs from 'video.js';
  import streaming  from '@videojs/http-streaming'; 
  export default {
    components: {
      videojs,
      streaming
    },
    data() {
      return {
        url: ""
      };
    },
    methods: {
      playVideo() {
        var self = this;
        var searchMask = "/index.m3u8";
        var regEx = new RegExp(searchMask, "ig");
        var replaceMask = ".mp4";

        var player = videojs(self.$refs.videojs);
        if (!self.url.includes(".mp4")){
            setTimeout(function(){
            self.url = self.url.replace(regEx, replaceMask);
            player.src({ type: "video/mp4", src: self.url});
            
            player.play();

            },1000)

        } 
      }
    },
    mounted() {
      var self = this;
      self.$store.dispatch("updateTheme", "dark");

      self.url = self.$route.query && self.$route.query.url;

      self.playVideo();
    }
  };
</script>

<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>

<style lang="scss">
  .video-js{
    width:100% !important;
    height: calc(100vh - 120px);
    align-content: center;
  }
</style>
